// removed by extract-text-webpack-plugin
module.exports = {"share_exhibit":"src-components-ShareExhibit----ShareExhibit-module---share_exhibit---3FAvy","share_title":"src-components-ShareExhibit----ShareExhibit-module---share_title---MgALn","share_list":"src-components-ShareExhibit----ShareExhibit-module---share_list---3SZD8","share_list_icon":"src-components-ShareExhibit----ShareExhibit-module---share_list_icon---umKe4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ShareExhibit/ShareExhibit.module.scss
// module id = 853
// module chunks = 168707334958949